import { UpsaleState } from '.';

type UpsaleSubset = Pick<UpsaleState, 'isStartUpsaleFlow' | 'isLoading' | 'purchasedUpsaleIds'>;

export const upsaleSelectors: {
  [K in keyof UpsaleSubset]: (state: { upsale: UpsaleSubset }) => UpsaleSubset[K];
} = {
  isStartUpsaleFlow: (state) => state.upsale.isStartUpsaleFlow,
  isLoading: (state) => state.upsale.isLoading,
  purchasedUpsaleIds: (state) => state.upsale.purchasedUpsaleIds,
};
